import axios from 'axios'
import { useCallback, useRef, useState } from 'react'

import { BASE_URL } from '../../../ini.json'
import { EpoTableItem } from '../../common/epoTypes'
import { useAppSelector } from '../../redux/hooks'

/**
 * It is not triggered automatically on component mount
 * @function fetchData - function to trigger the fetch
 *
 * Fetches and parse EPO json file saved on server
 * It maintains the request state and fetch trigger function
 * @param epoId - GUID
 * @returns Object containing:
 *  - fetching: boolean
 *  - error: boolean
 *  - data: EpoTableItem[]
 *  - fetchData: function to trigger the fetch
 *
 *
 */

export const useFetchEpoJsonData = (epoId?: string) => {
  const tenantId = useAppSelector(state => state.myProfile.tenantId)

  const [fetching, setFetching] = useState<boolean>(false)
  const [error, setError] = useState<boolean>(false)
  const [data, setData] = useState<EpoTableItem[]>([])

  const isFetchingRef = useRef(false)

  const fetchData = useCallback(async () => {
    if (isFetchingRef.current) return

    isFetchingRef.current = true
    setFetching(true)
    setError(false)

    const url = `${BASE_URL}/download/${tenantId}/${epoId}.json`

    try {
      const response = await axios.get<EpoTableItem[]>(url)

      if (!response) {
        setError(true)
      } else {
        setData(response.data)
      }
    } catch (error) {
      setError(true)
    } finally {
      setFetching(false)
    }
  }, [epoId, tenantId])

  return {
    fetching,
    error,
    data,
    fetchData,
  }
}
